package ir.site.zero1plus.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.style.*
import com.varabyte.kobweb.silk.style.selectors.hover
import ir.site.zero1plus.theme.*
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

sealed interface ButtonPrimaryKind : ComponentKind

val PrimaryButtonStyle = CssStyle<ButtonPrimaryKind> {
    base {
        Modifier.borderRadius(16.px)
    }
}

val PrimaryButtonNormalVariant = PrimaryButtonStyle.addVariant {
    val isDark = colorMode.isDark
    base {
        Modifier.backgroundColor(if (isDark) PrimaryDark else PrimaryLight)
            .color(if (isDark) BackgroundDark else BackgroundLight)
    }
    hover {
        Modifier.backgroundColor(HoverColor)
    }
}
val PrimaryButtonOutlinedVariant = PrimaryButtonStyle.addVariant {
    val isDark = colorMode.isDark
    base {
        Modifier.border(2.px, LineStyle.Solid, if (isDark) PrimaryDark else PrimaryLight)
            .color(if (isDark) PrimaryDark else PrimaryLight)
            .backgroundColor(Colors.Transparent)
            .setVariable(ButtonVars.BackgroundHoverColor, Color.rgb(0x00E0E0))
    }
    hover {
        Modifier.backgroundColor(HoverColor.copy(alpha = 25))
    }

}

@Composable
fun PrimaryButton(
    modifier: Modifier = Modifier,
    variant: CssStyleVariant<ButtonPrimaryKind> = PrimaryButtonNormalVariant,
    onClick: (SyntheticMouseEvent) -> Unit,
    buttonType: ButtonType = ButtonType.Button,
    content: @Composable () -> Unit
) {
    val finalModifier = PrimaryButtonStyle.toModifier(variant).then(modifier)
    Button(
        modifier = finalModifier,
        onClick = onClick,
        type = buttonType
    ) {
        content()
    }
}
